<template>
    <div class="comm_page_title">
        <div class="title">{{ title }}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    }
}
</script>

<style lang='scss'>
.comm_page_title {
    text-align: center;
    margin-bottom: 30px;

    .title {
        position: relative;
        display: inline-block;
        font-size: 24px;
        font-weight: bold;
        color: #333;

        &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -6px;
            transform: translateX(-50%);
            width: 20px;
            height: 3px;
            background-color: #3cc4da;
            border-radius: 2px;
        }
    }
}
</style>